<idp-book-widget-search-modal
  [recentSearchList]="recentSearchList"
  [savedSearchList]="savedSearchList"
  [searchModalTabs]="searchModalTabs"
  [predictiveSearchData]="predictiveSearchData"
  [isFullscreen]="isFullscreen"
  [modalOpen]="modalOpen"
  (searchModalClose)="handleSearchModalClose($event)"
  (selectedTabChange)="handleModalEvents({ type: 'tabChange', data: $event })"
  (searchStringChanged)="
    handleModalEvents({ type: 'searchStringChanged', data: $event })
  "
  (savedSearchItemSelected)="
    handleModalEvents({ type: 'saveSearchItemSelected', data: $event })
  "
  (recentSearchItemSelected)="
    handleModalEvents({ type: 'recentSearchItemSelected', data: $event })
  "
  (predictiveSearchItemSelected)="handlePredictiveSearchItemselection($event)"
>
  <mach-route-picker
    idpSwapIconClick
    [content]="routePickerContent"
    [cities]="routePickerCities"
    [error]="error"
    [idpErrorState]="error"
    (swapClicked)="swapClicked.emit()"
    (sendSelectedData)="handleRoutePickerClick($event)"
  ></mach-route-picker>
</idp-book-widget-search-modal>
